
import {useSelector as rawUseSelector, TypedUseSelectorHook, useDispatch} from "react-redux";
import { configureStore ,Middleware} from "@reduxjs/toolkit";
import axios from "axios";
import {persistStore,persistReducer} from "redux-persist";
import rootReducer, {RootState} from './rootReducer';
import storage from 'redux-persist/lib/storage/session'
const customMiddleware: Middleware<{}, RootState> = store => next => action => {
    const token = store.getState().auth.access_token ?? undefined;
    // @ts-ignore
    axios.defaults["headers"]['Authorization'] = token ? `Bearer ${token}` : 'Bearer';
    // @ts-ignore
    axios.defaults["headers"]['Access-Control-Allow-Origin'] = '*';
    axios.defaults.headers.post['Content-Type'] = 'application/json';
    axios.defaults.headers.put['Content-Type'] = 'application/json';
    axios.defaults.headers.delete['Content-Type'] = 'application/json';
    axios.defaults.headers.get['Content-Type'] = 'application/json';
    next(action);
};
const persistConfig = {
    key: "wildtour",
    storage,
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({
        serializableCheck: false,
    }).concat([customMiddleware]),
    devTools: true,
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;
export const persistor=persistStore(store);
export default store
